Apt.fn.extend('account-post', {}, {
	/**
	 * Bind actions for the done step
	 */
	doneSetup() {
		this.unprotect();
	}
});